import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions'; 
import * as HMS from "../../../common/component/Index";
import Modal from '../../../common/component/Modal';
import { isEqual, uniqBy } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import AntSelect, { AntOption } from '../../../common/component/AntSelect'
import { vietnameseStringToUnicode, formatMoney } from '../../../../../helpers/functions';
import { message, Tooltip } from 'antd'
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import * as vinWonderTicketActions from './../../../../../actions/vinWonderTicketAction';
import VinWonderTicketItems, { ticketTypes } from '../../../../../models/VinWonderTicketItems';
import ActionButton from 'antd/lib/modal/ActionButton';

class VinWonderTicketItemDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vinWonderTicketItem: this.props.vinWonderTicketState.detailItem,
            isGetItem: false,
            validation: {},
            isSubmit: false,
            action: DETAIL_ACTIONS.CREATE,
            currentTypeUpdate: ''
        };
    }

    componentDidMount() {
        this.initDetail();
    }
    

    initDetail() {
        if (this.props.itemSelected) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getVinWonderTicketItemDetail(this.props.itemSelected);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ action: DETAIL_ACTIONS.CREATE })
        if (nextProps.vinWonderState.detail.vinWonder && !isEqual(nextProps.vinWonderState.detail.vinWonder, this.props.vinWonderState.detail.vinWonder)) {
            this.props.getAllRef({siteCode: nextProps.vinWonderState.detail.vinWonder.siteCode, vinWonderType: nextProps.vinWonderState.detail.vinWonder.type})
        }

        if (nextProps.vinWonderTicketState.detailItem && !isEqual(nextProps.vinWonderTicketState.detailItem, this.props.vinWonderTicketState.detailItem)) {
            this.setState({ vinWonderTicketItem: nextProps.vinWonderTicketState.detailItem, action: nextProps.vinWonderTicketState.detailItem.id ? 'UPDATE' : this.state.action, currentTypeUpdate: nextProps.vinWonderTicketState.detailItem.ticketType });
        }

        if(nextProps.itemSelected && !isEqual(nextProps.itemSelected, this.props.itemSelected)) {
            this.props.getVinWonderTicketItemDetail(nextProps.itemSelected);
        }

        if(nextProps.visible && !isEqual(nextProps.visible, this.props.visible)) {
            this.setState({ vinWonderTicketItem: new VinWonderTicketItems() })
        }
    }


    render() {
        const { t, visible, vinWonderTicketState, vinWonderTicketItems } = this.props;
        const { isGetItem, vinWonderTicketItem, isSubmit, validation, action } = this.state;

        return (
            <Modal className="vw-ticket-item-detail"
                width={600}
                destroyOnClose={true}
                visible={visible}
                maskClosable={false}
                title={t(`item.vinWonderTicketItem.title`)}
                onOk={this.onSubmit} okText={action === DETAIL_ACTIONS.UPDATE ? t(`action.update`) : t(`action.create`)}
                onCancel={this.onCancel} cancelText={t(`action.cancel`)}
            >
                <Wrapper className="col-md-12">
                    <HMS.FormActionComponent
                        disabledFooter
                    >
                        <Wrapper className='col-md-12 basic-section'>
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={vinWonderTicketItem.ticketType}
                                validation={validation.ticketType}
                                labelTitle={t(`item.vinWonderTicketItem.ticketType`)}
                            >
                                <AntSelect className="select-site-code"
                                    showArrow showSearch
                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.vinWonderTicketItem.ticketType")).toLowerCase())}
                                    value={{...ticketTypes.find(item => item.value === vinWonderTicketItem.ticketType)}.text}
                                    onChange={(e) => this.onChange('ticketType', e)}
                                    style={{ width: '100%' }}
                                    filterOption={this.selectFilterSearch}
                                >
                                    {ticketTypes.map(item => (
                                        <AntOption key={item.value} value={item.value}>{item.text}</AntOption>
                                    ))}
                                </AntSelect>
                            </HMS.FormWrapperInputComponent>
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={vinWonderTicketItem.refId}
                                validation={validation.refId}
                                labelTitle={t(`item.vinWonderTicketItem.refId`)}
                            >
                                <AntSelect className="select-site-code"
                                    showArrow showSearch
                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.vinWonderTicketItem.refId")).toLowerCase())}
                                    value={{...vinWonderTicketState.listRefs.find(item => item.id == vinWonderTicketItem.refId)}.name}
                                    onChange={(e) => this.onChange('refId', e)}
                                    style={{ width: '100%' }}
                                    filterOption={this.selectFilterSearch}
                                >
                                    {uniqBy(vinWonderTicketState.listRefs, 'id').map(d => (
                                        <AntOption key={d.id} value={d.id}>
                                            {/* {d.id} - {d.name} - {formatMoney(d.price)} */}
                                            <Tooltip title={`${d.id} ${d.name} ( Giá: ${formatMoney(d.price)}đ )`} placement="topLeft">{`${d.id} - ${d.name} ( Giá: ${formatMoney(d.price)}đ )`}</Tooltip>
                                        </AntOption>
                                    ))}
                                </AntSelect>
                            </HMS.FormWrapperInputComponent>
                            {/* <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={vinWonderTicketItem.originalPrice}
                                validation={validation.originalPrice}
                                labelTitle={t(`item.vinWonderTickets.originalPrice`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`name`} onChange={(e) => this.onChange('originalPrice', e.target.value)}
                                    value={vinWonderTicketItem.originalPrice ? Func.formatMoney(vinWonderTicketItem.originalPrice.toString()) : ""} />
                            </HMS.FormWrapperInputComponent>
                            <HMS.FormWrapperInputComponent
                            
                                dataValidation={vinWonderTicketItem.salePrice}
                                validation={validation.salePrice}
                                labelTitle={t(`item.vinWonderTickets.salePrice`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={`name`} onChange={(e) => this.onChange('salePrice', e.target.value)}
                                    value={vinWonderTicketItem.salePrice ? Func.formatMoney(vinWonderTicketItem.salePrice.toString()) : ""} />
                            </HMS.FormWrapperInputComponent> */}
                        </Wrapper>
                    </HMS.FormActionComponent>
                </Wrapper>
            </Modal>
        )
    }

    selectFilterSearch = (input, option) => {
        const stringCompare = (option.props.children.props.children.split('('))[0]; 
        return this.getResultSearch(stringCompare, input)
    }

    getResultSearch = (result, input) => {
        const optionText = vietnameseStringToUnicode(result.toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0 ;
    }

    onChange = (fieldName, value) => {
        const vinWonderTicketItem = this.state.vinWonderTicketItem;
        const { vinWonderTicketState } = this.props;
        vinWonderTicketItem[fieldName] = value;
        if(fieldName === 'refId'){
            let rateCode = {...vinWonderTicketState.listRefs.find(item => item.id == vinWonderTicketItem.refId)}.rateCode;
            vinWonderTicketItem['rateCode'] = rateCode;
        }
        this.setState({ vinWonderTicketItem });
    };

    onSubmit = () => {
        const { t, vinWonderTicketItems } = this.props
        const { vinWonderTicketItem, action, currentTypeUpdate } = this.state;
        vinWonderTicketItem.vinWonderTicketId = this.props.vinWonderTicketId;
        if (this.validate()) {
            if (action === DETAIL_ACTIONS.CREATE) {
                if(!this.checkNotExitsTypeTicket(vinWonderTicketItems, vinWonderTicketItem.ticketType)) {
                    return message.error(t('validation.statusCode.code.VIN_WONDER_TICKET_ITEM_ALREADY_EXISTS'))
                }
                this.props.createVinWonderTicketItemDetail(vinWonderTicketItem)
            } else {
                const filterDataUpdate = vinWonderTicketItems.filter(ticket => ticket.ticketType !== currentTypeUpdate)
                if(!this.checkNotExitsTypeTicket(filterDataUpdate, vinWonderTicketItem.ticketType)) {
                    return message.error(t('validation.statusCode.code.VIN_WONDER_TICKET_ITEM_ALREADY_EXISTS'))
                }
                this.props.updatevinWonderTicketItemDetail({ vinWonderTicketItem, props: this.props })
            }
            this.props.onSubmit();
            this.destroyData();
        }
    }

    checkNotExitsTypeTicket = (vinWonderTicketItems, ticketType) => {
        if(vinWonderTicketItems.length === 0) {
            return true
        }

        const findData = vinWonderTicketItems.find(ticket => ticket.ticketType === ticketType) 
        if(!!findData) {
            return false
        }
        return true
    }

    destroyData = () => {
        this.props.setVinWonderTicketItemDetail(new VinWonderTicketItems())
    }

    onCancel = () => {
        this.props.onCancel();
        this.destroyData();
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                ticketType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderTicketItem.ticketType`)),
                refId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderTicketItem.refId`)),
                // originalPrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderTicketItem.originalPrice`)),
            },
            isNumber: {
                originalPrice: t('validation.statusCode.code.2'),
                salePrice: t('validation.statusCode.code.2'),
            },
        };
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.vinWonderTicketItem, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}

const mapStateToProps = state => {
    return {
        vinWonderTicketState: state.vinWonderTicketReducer,
        vinWonderState: state.vinWonderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllRef: (data) => dispatch(vinWonderTicketActions.getAllRef(data)),
        getVinWonderTicketItemDetail: (id) => dispatch(vinWonderTicketActions.getVinWonderTicketItemDetail(id)),
        setVinWonderTicketItemDetail: (vinWonderTicket) => dispatch(vinWonderTicketActions.setVinWonderTicketItemDetail(vinWonderTicket)),
        createVinWonderTicketItemDetail: (vinWonderTicketItem) => dispatch(vinWonderTicketActions.createVinWonderTicketItemDetail(vinWonderTicketItem)),
        updatevinWonderTicketItemDetail: (vinWonderTicketItem) => dispatch(vinWonderTicketActions.updateVinWonderTicketItemDetail(vinWonderTicketItem))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VinWonderTicketItemDetail))
